module.exports = __webpack_public_path__ + "static/media/poli-profile.37fed904.png";